var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h-100"},[_c(_setup.ReportExportsForm,{attrs:{"save-button-label":_vm.$t('reportExports.create'),"mode":"create"},on:{"save":_setup.create}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }